'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' });

var ErrorOutline = function ErrorOutline(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

ErrorOutline = (0, _pure2.default)(ErrorOutline);
ErrorOutline.muiName = 'SvgIcon';

exports.default = ErrorOutline;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/ErrorOutline.js
// module id = 2349
// module chunks = 0